
import Vue from "vue";
import { mapState, mapGetters } from "vuex";

export default Vue.extend({
  name: "PaymentIntegrityPicker",
  props: ["dateSync"],
  data: () => {
    return {
      menu: false,
      date: null as Date | null
    };
  },
  computed: {
    ...mapState(["PaymentIntegrities"]),
    ...mapGetters(["getPaymentIntegritiesAllowedDates"])
  },
  methods: {
    save(date: Date | null): void {
      date && this.$emit("filterByDate", date);
      (this.$refs.menu as HTMLFormElement).save(date);
    },
    allowedDates(date: string): boolean {
      const allowedDates = this.PaymentIntegrities.map(item => item.startDate);
      return allowedDates.includes(date);
    }
  },
  watch: {
    dateSync() {
      this.date = null;
    }
  }
});
